import React                       from 'react';
import { Observe }                 from 'rewire-core';
import {
  WithStyle,
  FormView,
}                                  from 'rewire-ui';
import { Theme }                   from '@material-ui/core/styles';
import DraggableResizableDialog    from '../ui/DraggableResizableDialog';
import addTimecardTestDialogModel  from './AddTimecardTestDialogModel';
import { withStyles }              from '../utility/styles';


const styles = (_theme: Theme) => ({
});

interface IAddTimecardTestDialogProps {
}

type AddTimecardTestDialogProps = WithStyle<ReturnType<typeof styles>, IAddTimecardTestDialogProps>;

class AddTimecardTestDialog extends React.PureComponent<AddTimecardTestDialogProps> {
  constructor(props: AddTimecardTestDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    addTimecardTestDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={addTimecardTestDialogModel.form} onSubmit={addTimecardTestDialogModel.actionFn('save')}>
        <div className='content'>
          <addTimecardTestDialogModel.form.field.name.Editor className='span1' />
        </div>
        <div className='content'>
          <addTimecardTestDialogModel.form.field.employee.Editor className='span1' />
        </div>
        <div className='content'>
          <addTimecardTestDialogModel.form.field.effectiveStart.Editor className='span1' />
          <addTimecardTestDialogModel.form.field.effectiveEnd.Editor className='span1' />
        </div>
        <div className='content'>
          <addTimecardTestDialogModel.form.field.code.Editor className='span1' />
        </div>
        <div className='content'>
          <addTimecardTestDialogModel.form.field.tags.Editor className='span1' />
        </div>
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: addTimecardTestDialogModel}}  DraggableResizableBoxProps={{minWidth: '295px', minHeight: '335px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IAddTimecardTestDialogProps>(styles, AddTimecardTestDialog);
